import React, { Component } from "react";
import '../IpPatientDetails.css';
import { Box, Paper, TextField, Button, Stack, Grid, Autocomplete, InputAdornment, Dialog, Tooltip, Typography, IconButton } from "@mui/material";
import { withTranslation } from 'react-i18next';
import { CommonPatientDetails, CommonPatientCard, ConsultantPatientCard, CommonGridToolBarWithFilterText } from "../../../../../Components/Common Components/CommonComponents";
import CommonValidation from "../../../../../Components/CommonFunctions/CommonValidation";
import { ImagePaths } from "../../../../../Utility/ImagePaths";
import { Colors } from "../../../../../Styles/Colors";
import ToastMsg from '../../../../../Components/ToastMsg/ToastMsg';
import RestAPIService from "../../../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../../../Utility/API/Serviceurls";
import { getCachevalue, localGetItem } from "../../../../../Utility/Services/CacheProviderService";
import { t } from "i18next";
import { CheckAccessFunc, convertDateTime, ConvertTimeToDate } from "../../../../../Components/CommonFunctions/CommonFunctions";
import Loader from '../../../../../Components/Loader';
import VoiceToText from '../../../../../Components/Common Components/VoiceToText';
import MicIcon from '@mui/icons-material/Mic';
import { grey } from '@mui/material/colors';
import { DataGrid } from "@mui/x-data-grid";
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import CloseIcon from '@mui/icons-material/Close';
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import PrintIcon from '@mui/icons-material/Print';
import { DateTime } from "luxon";

const enableList = ['early_morning', 'before_morning', 'mid_morning', 'lunch', 'early_evening', 'dinner', 'avoid_these', 'instruction'];
class NutritionChart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            patientData: {},
            attenderData: {},
            selected_template: null,
            is_template_slted: false,
            template_list: [],
            id: "",
            template_name: "",
            early_morning: "",
            before_morning: "",
            mid_morning: "",
            lunch: "",
            early_evening: "",
            dinner: "",
            avoid_these: "",
            instruction: "",
            clkedFrom: "",
            is_template_save: false,
            is_save: false,
            withOutAppointment: {},
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: '',
            clinic_id: JSON.parse(localGetItem('SelectedDoctorClinicId')),

            openNutritPopup: false,
            nutritionChartData: [],
            page: 0,
            pageSize: 10,
            isLoader: false,
            DateOpen: false,
            nutriDate: new Date(),
            isEdit: true,
            selectedId: null,
             NurseList: [],
        nurseName: null,
        }
    }
    componentDidMount() {
        let patientDetails = getCachevalue("IppatientData")
        let patients = JSON.parse(patientDetails)
        let appointmentDetail = getCachevalue("withoutAppointment");
        let details = JSON.parse(appointmentDetail);
         this.getNurseList();
        if (details?.patient_id === patients?.patient_id) {
            this.setState({
                withOutAppointment: details
            }, () => {
                this.getNutriChartDetails();
                this.getPatientData();
            })
        }
        this.setState({
            patientData: patients
        }, () => {
            this.getNutriTemplateDetails();
            this.getNutriChartDetails();
            this.getPatientData();
        })
    }

    LoaderFunction = (key) => {
        this.setState({
            isLoader: key
        })
    }

    getPatientData = () => {
        this.setState({
            attenderData: {}
        })
        let admission_id = this.state.patientData?.id || this.state.withOutAppointment?.ip_admission_id;
        let url = `${(localGetItem('isNewBilling') === "false" ? Serviceurls.IP_PATIENT_DETAILS : Serviceurls.IP_PATIENT_DETAILS_NEW)}?admission_id=${admission_id}`;
        if (this.props.is_From_IpNotes && this.state.clinic_id) {
            url = `${url}&clinic_id=${this.state.clinic_id}`
        }
        try {
            RestAPIService.getAll(url)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            attenderData: response.data.data[0]
                        })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.errorMsgFunc(error.response.data.message)
                    } else {
                        this.errorMsgFunc(error.message)
                    }
                })
        } catch (error) {
            this.errorMsgFunc(error.message)
        }
    }

    getNutriChartDetails = () => {
        let admission_id = this.state.patientData?.id || this.state.withOutAppointment?.ip_admission_id;
        try {
            RestAPIService.getAll(`${Serviceurls.IP_DOC_NUTRITION_CHART}?ip_admission_id=${admission_id}`)
                .then(response => {
                    if (response.data.status === "success") {
                        let data = response.data.data[0];
                        const nutritionChartData = response?.data?.data || [];
                        const mappedData = nutritionChartData.map(item => {
                            const foundNurse = this.state.NurseList.find(
                                nurse => nurse.staff_id === item.nurse_profile_id
                            );
                            return {
                                ...item,
                                nurse_name: foundNurse ? foundNurse.nurse : item.nurse_name || '',
                            };
                        });
                        this.setState({ nutritionChartData: mappedData })
                        // this.setState({
                        //     id: data?.id,
                        //     early_morning: data?.early_morning,
                        //     before_morning: data?.before_morning,
                        //     mid_morning: data?.mid_morning,
                        //     lunch: data?.lunch,
                        //     early_evening: data?.early_evening,
                        //     dinner: data?.dinner,
                        //     avoid_these: data?.avoid_these,
                        //     instruction: data?.instruction,
                        // });
                    }
                })
                .catch(error => {
                    if (error?.response?.data?.status === "fail") {
                        this.errorMsgFunc(error.response.data.message);
                    } else {
                        this.errorMsgFunc(error.message);
                    }
                });
        } catch (e) {
            this.errorMsgFunc(e.message);
        }
    }

    getNutriTemplateDetails = () => {
        const myUser = JSON.parse(localGetItem("loggedInUserInfo"));
        try {
            RestAPIService.getAll(`${Serviceurls.IP_DOC_NUTRITION_CHART_TEMPLATE}?doctor_id=${myUser?.doctor_id || this.state.patientData?.doctor_id}`)
                .then(response => {
                    if (response.data.status === "success") {
                        this.setState({
                            template_list: response.data.data,
                        });
                    }
                })
                .catch(error => {
                    if (error?.response?.data?.status === "fail") {
                        this.errorMsgFunc(error.response.data.message);
                    } else {
                        this.errorMsgFunc(error.message);
                    }
                });
        } catch (e) {
            this.errorMsgFunc(e.message);
        }
    }

    getNutriPrint = (item) => {
        let admission_id = this.state.patientData?.id || this.state.withOutAppointment?.ip_admission_id;
        try {
            RestAPIService.getAll(`${Serviceurls.IP_DOC_NUTRITION_CHART}?ip_admission_id=${admission_id}&export_type=${"pdf"}&id=${item?.id}`)
                .then((response) => {
                    if (response) {
                        //Create a Blob from the PDF Stream
                        const file = new Blob(
                            [response.data],
                            { type: 'application/pdf' });
                        //Build a URL from the file
                        const fileURL = URL.createObjectURL(file);
                        //Open the URL on new Window
                        window.open(fileURL);
                    }
                }).catch((error) => {
                    if (error?.response?.data?.status === 'fail') {
                        this.errorMsgFunc(error.response.data.message)
                    } else {
                        this.errorMsgFunc(error.message)
                    }
                })
        } catch (error) {
            this.errorMsgFunc(error.message)
        }
    }

    deleteNutritionChartData = (item) => {
        try {
            let data = { id: item?.id }
            RestAPIService.delete(Serviceurls.IP_DOC_NUTRITION_CHART, data)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.successMsgFunc(response?.data?.message)
                        this.getNutriChartDetails()
                    }
                }).catch((error) => {
                    if (error?.response?.data?.status === 'fail') {
                        this.errorMsgFunc(error.response.data.message)
                    } else {
                        this.errorMsgFunc(error.message)
                    }
                })
        } catch (error) {
            this.errorMsgFunc(error.message)
        }
    }

    getNurseList = () => {
    try {
        RestAPIService.getAll(Serviceurls.FO_STAFF_LIST + `?clinic_id=${this.state.clinic_id}`)
            .then((response) => {
                if (response.data.status === "success") {
                    
                    this.setState({
                        NurseList: response.data.data
                    }, () => {
                        if (this.state.NurseList?.length && localGetItem("NurseId") && !this.state?.nurseName?.staff_id) {
                            let nurseId = JSON.parse(localGetItem("NurseId"))
                            let nurseData = this.state.NurseList.find((item) => item.staff_id === nurseId)
                            this.setState({
                                nurseName: nurseData
                            })
                        }
                        this.getNutriChartDetails();
                    })
                }
            }).catch((error) => {
                this.errorMsgFunc(error?.response?.data?.message || error.message)
            })
    } catch (error) {
        this.errorMsgFunc(error.message)
    }
}

    errorMsgFunc = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message,
            is_template_save: false,
            is_save: false,
        })
    }

    successMsgFunc = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message,
            is_template_save: false,
            is_save: false,
        })
    }

    handleClear = () => {
        this.setState(
            {
                template_name: "",
                selected_template: null,
                is_template_slted: false,
                early_morning: "",
                before_morning: "",
                mid_morning: "",
                lunch: "",
                early_evening: "",
                dinner: "",
                avoid_these: "",
                instruction: "",
                is_template_save: false,
                is_save: false,
                clkedFrom: "",
                isEdit: false,
                selectedId: null,
                openNutritPopup: false,
                nutriDate: new Date(),
                nurseName: null,
            }, () => {
                if (this.state.NurseList?.length && localGetItem("NurseId")) {
                    let nurseId = JSON.parse(localGetItem("NurseId"))
                    let nurseData = this.state.NurseList.find((item) => item.staff_id === nurseId)
                    this.setState({
                        nurseName: nurseData
                    })
                }
            }
        )
    }

    handleChange = (e) => {
        let { name, value } = e.target;
        value = value.trimStart();
        if ((name !== "template_name" && value.length > 250) || value === "") {
            value = value.substring(0, 250);
        }
        this.setState({
            [name]: value
        })
    }

    listenPopUp = () => {
        this.setState({
            listenPopUp: false
        })
    }

    voiceToTextgetter = (textStorage) => {
        if (textStorage) {
            const { clkedFrom } = this.state;
            if (clkedFrom) {
                this.setState(prevState => {
                    const newValue = prevState[clkedFrom]
                        ? prevState[clkedFrom] + " " + textStorage
                        : textStorage;
                    const finalValue = newValue?.length > 250 ? newValue.substring(0, 250) : newValue;
                    return {
                        [clkedFrom]: finalValue
                    };
                });
            }
        } else {
            this.setState({ listenPopUp: false });
        }
    }

    renderVoiceTexbox = (label, statekey) => {
        const { t } = this.props
        let states = this.state;
        return (
            <TextField
                sx={{ width: '100%' }}
                multiline
                rows={2}
                label={t(label)}
                name={statekey}
                value={states[statekey] ? states[statekey] : ""}
                variant="outlined"
                onChange={this.handleChange}
                InputProps={{
                    endAdornment: <InputAdornment position="end">
                        <MicIcon sx={{ color: grey[1000], cursor: "pointer" }}
                            onClick={() => { this.setState({ listenPopUp: true, clkedFrom: statekey }) }} />
                    </InputAdornment>
                }}
            />)
    }

    renderTextBox(label, statekey, isDisabled = false) {
        const { t } = this.props;
        let { selected_template, template_list } = this.state;
        let states = this.state;
        return (
            <div id="eMed_srvConfig_divs">
                {statekey === "selected_template" ?
                    <Autocomplete
                        disableClearable
                        value={selected_template ? selected_template : null}
                        sx={{ width: "18dvw", fontSize: "0.9vw" }}
                        size="small"
                        options={template_list?.length > 0 ? [...template_list] : []}
                        getOptionLabel={option => typeof (option) === "string" ? option : option.template_name}
                        onChange={(e, value) => {
                            this.setState({
                                selected_template: value,
                                is_template_slted: true,
                                template_name: value.template_name,
                                early_morning: value.early_morning,
                                before_morning: value.before_morning,
                                mid_morning: value.mid_morning,
                                lunch: value.lunch,
                                early_evening: value.early_evening,
                                dinner: value.dinner,
                                avoid_these: value.avoid_these,
                                instruction: value.instruction,
                            })
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={t(label)}
                                autoComplete="off"
                                size="small"
                                InputProps={{
                                    ...params.InputProps,
                                }}
                            />
                        )}
                    />
                    : <TextField
                        sx={{ width: "18dvw" }}
                        size="small"
                        autoComplete="off"
                        label={t(label)}
                        name={statekey}
                        value={states[statekey] ? states[statekey] : ""}
                        disabled={isDisabled}
                        onChange={this.handleChange}
                    />}
            </div>
        )
    }

    handleTemplateSave = () => {
        try {
            let states = this.state;
            let isDataAvailable = enableList.some(key => states[key]);
            if (isDataAvailable && states.template_name) {
                let data = {
                    "doctor_id": states?.patientData?.doctor_id,
                    'template_name': CommonValidation.removeSpace(states.template_name),
                    'early_morning': CommonValidation.removeSpace(states.early_morning),
                    'before_morning': CommonValidation.removeSpace(states.before_morning),
                    'mid_morning': CommonValidation.removeSpace(states.mid_morning),
                    'lunch': CommonValidation.removeSpace(states.lunch),
                    'early_evening': CommonValidation.removeSpace(states.early_evening),
                    'dinner': CommonValidation.removeSpace(states.dinner),
                    'avoid_these': CommonValidation.removeSpace(states.avoid_these),
                    'instruction': CommonValidation.removeSpace(states.instruction),
                }
                if (states.is_template_slted) { data["id"] = states?.selected_template?.id }
                RestAPIService.create(data, Serviceurls.IP_DOC_NUTRITION_CHART_TEMPLATE).
                    then((response) => {
                        if (response.data.status === "success") {
                            this.getNutriTemplateDetails()
                            this.successMsgFunc(response.data.message)
                            this.setState({
                                // template_name: "",
                                is_template_slted: false,
                                selected_template: null
                            }
                            )
                        } else {
                            this.errorMsgFunc(response.data.message)
                        }
                    }).catch(error => {
                        if (error?.response?.data?.status === "fail") {
                            this.errorMsgFunc(error.response.data.message)
                        } else {
                            this.errorMsgFunc(error.message)
                        }
                    })
            }
        } catch (error) {
            this.errorMsgFunc(error.message)
        }
    }

    handleSave = () => {
        try {
            let states = this.state;
            let UserData = JSON.parse(localGetItem("loggedInUserInfo"));
            let isDataAvailable = enableList.some(key => states[key]);
            let startDate = new Date(this.state.nutriDate)
            let date = DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd')
            let time = DateTime.fromJSDate(startDate).toLocaleString(DateTime.TIME_24_WITH_SECONDS);
            let date_time = `${date} ${time}`
            if (!states.nurseName?.staff_id) {
            this.errorMsgFunc("Please select a nurse");
            return;
            }
            if (isDataAvailable) {
                let data = {
                    "id": states?.selectedId,
                    'ip_admission_id': states?.patientData?.id,
                    "doctor_id": states?.patientData?.doctor_id,
                    'early_morning': CommonValidation.removeSpace(states.early_morning),
                    'before_morning': CommonValidation.removeSpace(states.before_morning),
                    'mid_morning': CommonValidation.removeSpace(states.mid_morning),
                    'lunch': CommonValidation.removeSpace(states.lunch),
                    'early_evening': CommonValidation.removeSpace(states.early_evening),
                    'dinner': CommonValidation.removeSpace(states.dinner),
                    'avoid_these': CommonValidation.removeSpace(states.avoid_these),
                    'instruction': CommonValidation.removeSpace(states.instruction),
                    'date_time': date_time,
                    'nurse_profile_id': states?.nurseName?.staff_id || null,
                }
                RestAPIService.create(data, Serviceurls.IP_DOC_NUTRITION_CHART)
                    .then((response) => {
                        if (response.data.status === "success") {
                            this.handleClear();
                            this.setState({ id: "", selectedId: null, openNutritPopup: false })
                            this.getNutriChartDetails();
                            this.successMsgFunc(response.data.message)
                        } else {
                            this.errorMsgFunc(response.data.message)
                        }
                    }).catch(error => {
                        if (error?.response?.data?.status === "fail") {
                            this.errorMsgFunc(error.response.data.message)
                        } else {
                            this.errorMsgFunc(error.message)
                        }
                    })
            }
        } catch (error) {
            this.errorMsgFunc(error.message)
        }
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    addNewNutritionChartpopup = () => {
        try {
            let states = this.state;
            let UserData = JSON.parse(localGetItem("loggedInUserInfo"));
            const checkuserAccess = this.props.is_From_IpNotes ? false :
                CheckAccessFunc("front_office", "In Patients", "Clinical Notes", "Nutrition Chart", "SubTab")?.editAccess ?
                    this.state.withOutAppointment?.is_ip : true;
            let isTemplateEnable = enableList?.some(key => states[key]);
            let maximumDate = this.state.patientData?.discharge_date ? new Date(this.state.patientData?.discharge_date) : new Date()
            return (
                <Dialog open={this.state.openNutritPopup} maxWidth='lg' fullWidth>
                    <Box className='com_billing_popup'>
                        <Paper className="eMed_medication_Div" elevation={2}>
                            <div className="eMed_lab_subDiv">
                                <div className='eMed_medication_rightHead' style={{ backgroundColor: Colors.DataTblHeaderbg }}>
                                    <p className='eMed_recPayment_rightHead_txt'>{t("Nutrition Chart")}</p>
                                    <Box component={'div'} display={'flex'}>
                                        {this.renderTextBox("Select Template", "selected_template")}
                                        <IconButton sx={{ ml: '0.5rem', mr: '0.5rem' }}
                                            onClick={() => this.handleClear()}
                                        ><CloseIcon /></IconButton>
                                    </Box>
                                </div>
                                <Stack className="emedhub_medication_RightContentBox" direction="column" justifyContent="center" alignItems="flex-start" spacing={0.5}>
                                    <Stack direction="row" justifyContent="space-between" alignItems="center" >
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DateTimePicker
                                                open={this.state.DateOpen}
                                                onOpen={() => { this.setState({ DateOpen: true }) }}
                                                onClose={() => { this.setState({ DateOpen: false }) }}
                                                inputFormat='DD-MM-YYYY & hh:mm A'
                                                value={this.state.nutriDate}
                                                minDate={new Date(this.state.patientData?.admission_date)}
                                                maxDate={maximumDate}
                                                onChange={(newDate) => { this.setState({ nutriDate: newDate }) }}
                                                renderInput={(params) => <TextField size='small' autoComplete='off'
                                                    onKeyDown={(e) => e.preventDefault()}
                                                    onClick={() => { this.setState({ DateOpen: true }) }}
                                                    {...params}
                                                    fullWidth
                                                    sx={{ marginRight: "0.5vw", width: "15vw" }}
                                                />}
                                            />
                                        </LocalizationProvider>
                                        {this.renderTextBox("Template Name", "template_name", !isTemplateEnable)}
                                        <Autocomplete
                                            size='small'
                                            sx={{margin:'0.7vw'}}
                                            options={this.state.NurseList || []}
                                            getOptionLabel={(option) => option.nurse}
                                            value={this.state.nurseName}
                                            onChange={(event, newValue) => {
                                                this.setState(() => ({
                                                    nurseName: newValue
                                                }))
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    sx={{ width: "15dvw" }}
                                                    {...params}
                                                    label={t("Nurse Name *")}
                                                />
                                            )}
                                        />
                                        <Button
                                            disabled={(checkuserAccess || this.state.is_template_save || this.state.selected_template || !isTemplateEnable || !states.template_name)}
                                            variant='contained' size="small" id="eMed_recPayment_btn"
                                            onClick={() => {
                                                this.setState({ is_template_save: true, },
                                                    () => { this.handleTemplateSave() })
                                            }}>{t("Save")}</Button>
                                    </Stack>
                                    <div className="eMed_nutri_txtDiv">
                                        {this.renderVoiceTexbox("Early Morning", "early_morning")}
                                        {this.renderVoiceTexbox("Before Morning", "before_morning")}
                                        {this.renderVoiceTexbox("Mid Morning", "mid_morning")}
                                        {this.renderVoiceTexbox("Lunch", "lunch")}
                                        {this.renderVoiceTexbox("Early Evening", "early_evening")}
                                        {this.renderVoiceTexbox("Dinner", "dinner")}
                                        {this.renderVoiceTexbox("Avoid These", "avoid_these")}
                                        {this.renderVoiceTexbox("Instruction", "instruction")}
                                    </div>
                                </Stack>
                            </div>
                            <Stack spacing={2} direction="row" id='eMed_recPayment_rightBtnCon' sx={{ backgroundColor: Colors.DataTblHeaderbg }} alignItems="center" justifyContent="center">
                                <Button variant='outlined' disabled={this.state.withOutAppointment?.is_ip} size="small" id="eMed_recPayment_btn" onClick={() => { this.handleClear() }}>{t("Cancel")}</Button>
                                <Button
                                    disabled={checkuserAccess || this.state.is_save || !isTemplateEnable}
                                    variant='contained' size="small" id="eMed_recPayment_btn"
                                    onClick={() => {
                                        this.setState({ is_save: true, },
                                            () => { this.handleSave() })
                                    }}>{t("Save")}</Button>
                            </Stack>
                        </Paper>
                    </Box>
                </Dialog>
            )
        } catch (error) {
            this.errorMsgFunc(error.message)
        }
    }

    convertDateFormat = (input) => {
        // Parse using the input format
        const dt = DateTime.fromFormat(input, 'dd-MM-yyyy hh:mm a');
        // Format to desired output
        return dt.toFormat('yyyy-MM-dd hh:mm a');
    }

    onEditHandler = (item) => {
        try {
            let convertDate = this.convertDateFormat(item?.date_time)
            let date = new Date(convertDate)
            const existingNurse = this.state.NurseList.find(
            nurse => nurse.staff_id === item.nurse_profile_id
            );
            this.setState({
                template_name: item?.template_name,
                selected_template: null,
                is_template_slted: false,
                early_morning: item?.early_morning,
                before_morning: item?.before_morning,
                mid_morning: item?.mid_morning,
                lunch: item?.lunch,
                early_evening: item?.early_evening,
                dinner: item?.dinner,
                avoid_these: item?.avoid_these,
                instruction: item?.instruction,
                isEdit: true,
                selectedId: item?.id,
                nutriDate: date,
                openNutritPopup: true,
                nurseName: existingNurse || null
            })
        } catch (error) {
            this.errorMsgFunc(error.message)
        }
    }

    gridToolBar = () => {
        return <Box><CommonGridToolBarWithFilterText /></Box>
    }

    render() {
        const { t } = this.props;
        let states = this.state;
        let UserData = JSON.parse(localGetItem("loggedInUserInfo"));
        const checkuserAccess = this.props.is_From_IpNotes ? false :
            CheckAccessFunc("front_office", "In Patients", "Clinical Notes", "Nutrition Chart", "SubTab")?.editAccess ?
                this.state.withOutAppointment?.is_ip : true;

        let data = {
            lineOne: t("AttenderName"),
            lineTwo: `${states["attenderData"]["attender_name"] ? states["attenderData"]["attender_name"] : "-"}`,
            lineFour: t('ContactNumber'),
            LineFive: `${states["attenderData"]["attender_mobile"] ? states["attenderData"]["attender_mobile"] : "-"}`
        }

        let Consultant = {
            image: ImagePaths.Doctor_Icon.default,
            width: "2.3vw",
            height: "2.3vw",
            lineOne: t("ConsultantName"),
            lineTwo: `${states["attenderData"]["doctor_name"] ? states["attenderData"]["doctor_name"] : "-"}`
        }
        this.state.nutritionChartData?.forEach((element, index) => element.sno = index + 1)
        const columns = [
            {
                field: 'date_time', headerName: 'Date & Time', flex: 0.1,
                renderCell: (params) => {
                    let date = params?.row?.date_time
                    return (
                        <Box>
                            {date ? date?.length > 10 ?
                                <Tooltip placement="top" title={date}><Typography>{date?.slice(0, 10) + '...'}</Typography></Tooltip> :
                                <Typography>{date}</Typography> : '-'}
                        </Box>
                    )
                }
            },
            {
                field: 'early_morning', headerName: 'E.Morning', flex: 0.1,
                renderCell: (params) => {
                    let eMor = params?.row?.early_morning
                    return (
                        <Box>
                            {eMor ? eMor?.length > 10 ?
                                <Tooltip placement="top" title={eMor}><Typography>{eMor?.slice(0, 10) + '...'}</Typography></Tooltip> :
                                <Typography>{eMor}</Typography> : '-'}
                        </Box>
                    )
                }
            },
            {
                field: 'before_morning', headerName: 'B.Morning', flex: 0.1,
                renderCell: (params) => {
                    let bMor = params?.row?.before_morning
                    return (
                        <Box>
                            {bMor ? bMor?.length > 10 ?
                                <Tooltip placement="top" title={bMor}><Typography>{bMor?.slice(0, 10) + '...'}</Typography></Tooltip> :
                                <Typography>{bMor}</Typography> : '-'}
                        </Box>
                    )
                }
            },
            {
                field: 'mid_morning', headerName: 'M.Morning', flex: 0.1,
                renderCell: (params) => {
                    let mMor = params?.row?.mid_morning
                    return (
                        <Box>
                            {mMor ? mMor?.length > 10 ?
                                <Tooltip placement="top" title={mMor}><Typography>{mMor?.slice(0, 10) + '...'}</Typography></Tooltip> :
                                <Typography>{mMor}</Typography> : '-'}
                        </Box>
                    )
                }
            },
            {
                field: 'lunch', headerName: 'Lunch', flex: 0.1,
                renderCell: (params) => {
                    let lunch = params?.row?.lunch
                    return (
                        <Box>
                            {lunch ? lunch?.length > 10 ?
                                <Tooltip placement="top" title={lunch}><Typography>{lunch?.slice(0, 10) + '...'}</Typography></Tooltip> :
                                <Typography>{lunch}</Typography> : '-'}
                        </Box>
                    )
                }
            },
            {
                field: 'early_evening', headerName: 'E.Evening', flex: 0.1,
                renderCell: (params) => {
                    let eEve = params?.row?.early_evening
                    return (
                        <Box>
                            {eEve ? eEve?.length > 10 ?
                                <Tooltip placement="top" title={eEve}><Typography>{eEve?.slice(0, 10) + '...'}</Typography></Tooltip> :
                                <Typography>{eEve}</Typography> : '-'}
                        </Box>
                    )
                }
            },
            {
                field: 'dinner', headerName: 'Dinner', flex: 0.1,
                renderCell: (params) => {
                    let dinner = params?.row?.dinner
                    return (
                        <Box>
                            {dinner ? dinner?.length > 10 ?
                                <Tooltip placement="top" title={dinner}><Typography>{dinner?.slice(0, 10) + '...'}</Typography></Tooltip> :
                                <Typography>{dinner}</Typography> : '-'}
                        </Box>
                    )
                }
            },
            {
                field: 'avoid_these', headerName: 'Avoid', flex: 0.1,
                renderCell: (params) => {
                    let avoid = params?.row?.avoid_these
                    return (
                        <Box>
                            {avoid ? avoid?.length > 10 ?
                                <Tooltip placement="top" title={avoid}><Typography>{avoid?.slice(0, 10) + '...'}</Typography></Tooltip> :
                                <Typography>{avoid}</Typography> : '-'}
                        </Box>
                    )
                }
            },
            {
                field: 'instruction', headerName: 'Instruction', flex: 0.1,
                renderCell: (params) => {
                    let inst = params?.row?.instruction
                    return (
                        <Box>
                            {inst ? inst?.length > 10 ?
                                <Tooltip placement="top" title={inst}><Typography>{inst?.slice(0, 10) + '...'}</Typography></Tooltip> :
                                <Typography>{inst}</Typography> : '-'}
                        </Box>
                    )
                }
            },
            {
                field: 'nurse_name', headerName: 'Nurse Name', flex: 0.1,
                renderCell: (params) => {
                    let nurseName = params?.row?.nurse_name;
                    return (
                        <Box>
                            {nurseName ? nurseName.length > 15 ?
                                <Tooltip placement="top" title={nurseName}>
                                    <Typography>{nurseName.slice(0, 9) + '...'}</Typography>
                                </Tooltip> :
                                <Typography>{nurseName}</Typography> : '-'}
                        </Box>
                    )
                }
            },
            {
                field: 'action', headerName: 'Action', flex: 0.1, align: 'center', headerAlign: 'center',
                renderCell: (params) => {
                    return (
                        <Box>
                            <IconButton
                                onClick={() => this.onEditHandler(params?.row)}
                            ><EditIcon color="primary" /></IconButton>
                            <IconButton
                                onClick={() => this.deleteNutritionChartData(params?.row)}
                            ><DeleteForeverIcon color="error" /></IconButton>
                            <IconButton
                                onClick={() => this.getNutriPrint(params?.row)}
                            ><PrintIcon color="primary" /></IconButton>
                        </Box>
                    )
                }
            },
        ]
        return (
            <Box sx={{ backgroundColor: Colors.configHomeBg, height: '74dvh', p: '0.625vw' }}>
                <Grid container className="" >
                    <Stack className="eMed_medicationCard_header" direction="row" justifyContent="space-between" alignItems="center" sx={{ width: '100%' }}>
                        <Stack direction="row" justifyContent="space-evenly" alignItems="center" spacing={1.2} >
                            <Stack className="eMed_recCard_div" sx={{ width: "23vw", backgroundColor: Colors.white }} >
                                <CommonPatientDetails data={this.state.patientData} showDetailed={true} />
                            </Stack>
                            <CommonPatientCard details={data} showDetailed={true} />
                            <ConsultantPatientCard name={Consultant} width={"20dvw"} />
                        </Stack>
                        {/* <Button className='eMed_usrconf_btn' onClick={() => { this.getNutriPrint() }}>
                            <img src={ImagePaths.LabPrintIcon.default} alt="print" className='eMed_action_img' />
                        </Button> */}
                    </Stack>
                </Grid>
                <Box component={'div'} height={'64dvh'}>
                    <Box component={'div'} p={'0.5rem'} display={'flex'} alignItems={'center'} justifyContent={'flex-end'}>
                        <Button variant="contained"
                            sx={{ textTransform: 'capitalize', height: '4.5dvh', width: '10dvw' }}
                            onClick={() => this.setState({ openNutritPopup: true })}
                        >Add Chart</Button>
                    </Box>
                    <Box component={'div'} sx={{ backgroundColor: Colors.white, height: '57dvh' }}>
                        <DataGrid
                            rows={this.state.nutritionChartData}
                            page={this.state.page}
                            columns={columns}
                            hideFooterSelectedRowCount
                            getRowId={(row) => row.sno}
                            pageSize={this.state.pageSize}
                            onPageChange={(newPage) => { this.setState({ page: newPage }) }}
                            onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                            rowsPerPageOptions={[10, 20, 30]}
                            loading={this.state.isLoader}
                            localeText={{
                                toolbarColumns: "",
                                toolbarDensity: "",
                                toolbarExport: "",
                                toolbarFilters: "",
                                toolbarExportPrint: ""
                            }}
                            components={{
                                // Toolbar: CommonGridHeader.CommonToolBar,
                                // Toolbar: this.gridToolBar,
                                NoRowsOverlay: () => (
                                    <Stack height="100%" alignItems="center" justifyContent="center">
                                        {t("NoRecordsFound")}
                                    </Stack>
                                )
                            }}
                            headerHeight={40}
                            disableColumnSelector
                        />
                    </Box>
                </Box>
                {this.addNewNutritionChartpopup()}
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.listenPopUp ?
                    <VoiceToText
                        voiceTextConverter={this.voiceToTextgetter.bind(this)}
                        listenPopUp={this.listenPopUp.bind(this)}
                    /> : null
                }
                <Loader loaderOpen={this.state.isLoader} />
            </Box>
        )
    }
}
export default withTranslation()(NutritionChart);